import React, { useContext } from "react";
import { TreeContext, ProfileContext, ProjectContext } from "../../Store";
import Box from "@mui/material/Box";
import ReactLoading from "react-loading";

// Ladebildschirm wenn Katalog/Profil lädt oder nach Aktualisierung keine Seite geladen ist

const LoadingText = () => {
  const tree = useContext(TreeContext);
  const profile = useContext(ProfileContext);
  const project = useContext(ProjectContext);
  const TreeClicked = tree.clicked;
  const ProfilClicked = profile.clicked;
  const ProjectClicked = project.clicked;

  if (TreeClicked) {
    return <p>Katalog wird geladen...</p>;
  } else if (ProfilClicked) {
    return <p>Profile werden geladen...</p>;
  } else if (ProjectClicked) {
    return <p>Projekte werden geladen...</p>;
  } else {
    return <p>Menü-Punkt auswählen...</p>;
  }
};

const LoadingScreen = () => {
  return (
    <div>
      <Box sx={{ marginTop: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <ReactLoading
          type={"spinningBubbles"}
          color={"#4D6F8C"}
          height={100}
          width={100}
        />
      </Box>
      <Box sx={{ marginTop: "20px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <LoadingText />
      </Box>
    </div>
  );
};

export default LoadingScreen;
